// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/crops/';
export const actions = {
  SET_ALL_CROPS: `${typePrefix}SET_ALL_CROPS`
};

// Reducer

export default function reducer (
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_ALL_CROPS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
}

// Action Creators

export const setCropList = ( {crops} ) => {
  return {
    type: actions.SET_ALL_CROPS,
    payload: crops
  };
};
